import { Middleware } from "redux";

import { Events } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/core/store";
import { TreeEngineActions } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/extensions/client";
import { Locale } from "@com.mgmtp.a12.utils/utils-localization/lib/main";

export const selectTreeRowMiddleware: Middleware<unknown, { locale: Locale }> = api => next => action => {
	const result = next(action);

	if (
		TreeEngineActions.event.match(action) &&
		Events.onRowClicked.match(action.payload.engineAction) &&
		action.payload.engineAction.payload.event === "select_row_action"
	) {
		api.dispatch(
			TreeEngineActions.event({
				activityId: action.payload.activityId,
				engineAction: Events.onNodeMultiSelectionClicked(action.payload.engineAction.payload)
			})
		);
	}

	return result;
};
